// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"45a9023b","441":"8f8be65c","453":"98682b40","674":"bfe34f75","706":"eb375152","812":"6f091652","887":"66167812","964":"90fe4fe9","982":"e7af6307"}[chunkId] + ".chunk.js";
};